import { render, staticRenderFns } from "./KamiSearchResultBrief.vue?vue&type=template&id=cafb9fe2&scoped=true&"
import script from "./KamiSearchResultBrief.vue?vue&type=script&lang=js&"
export * from "./KamiSearchResultBrief.vue?vue&type=script&lang=js&"
import style0 from "./KamiSearchResultBrief.vue?vue&type=style&index=0&id=cafb9fe2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafb9fe2",
  null
  
)

export default component.exports